import axios from 'axios'
import _URL from '../../URL/index';

export default {
    services: {
        getFlights: (number, date) => {
            return axios.get(`${_URL._API}/flights/${date}/${number}`);
        }
    }
}